import { toast } from "react-toastify"
import { BACKEND } from "../../../config/configEnvs"
import { useEffect, useState } from "react"
import axios from "axios"
import { FaArrowLeft, FaEye, FaEyeSlash, FaImage, FaPlus, FaSpinner, FaTrash } from "react-icons/fa"
import Modal from "../../ui/Modal"
import { Button } from "@mui/material"
import { useSelector } from "react-redux"

const SeguimientoFormularioScreen = ({serviceId}) => {

  const user = useSelector((state) => state.auth.user)

  const [loadingStatus, setLoadingStatus] = useState(false) // Estado de carga de la pantalla
  const [loadingSurvey, setLoadingSurvey] = useState(false) // Estado de carga al seleccionar una encuesta

  const [serviceSurveys, setServiceSurveys] = useState([]) // Encuentas del servicio

  const [selectedSurveyId, setSelectedSurveyId] = useState("") // Plantilla seleccionada
  const [selectedSurvey, setSelectedSurvey] = useState({})
  const [selectedSurveyQuestions, setSelectedSurveyQuestions] = useState([]) // Encuesta seleccionada
  const [surveyViewActive, setSurveyViewActive] = useState(false) // Vista de encuesta seleccionada activa

  const [newSurveyModal, setNewSurveyModal] = useState(false) // Estado del modal de plantillas

  const [evidenceModal, setEvidenceModal] = useState(false) // Modal de evidencias

  const [evidenceToView, setEvidenceToView] = useState([]) // Imagenes a visualizar

  const [surveyType, setSurveyType] = useState("Seleccionar") // Tipo de plantilla a crear

  const [surveysCreated, setSurveysCreated] = useState([]) // Encuestas creadas - plantillas

  const [titleNewSurvey, setTitleNewSurvey] = useState("") // Título de nueva encuesta
  const [descriptionNewSurvey, setDescriptionNewSurvey] = useState("") // Descripción de nueva encuesta

  const getSurvey = async () => { // Obtener las respuestas de las encuestas
    try {
      setLoadingStatus(true)
      const response = await axios.get(`${BACKEND}/api/encuestaSatisfaccionRespuesta?where[serviceCot][equals]=${serviceId}`)
      setServiceSurveys(response.data.docs)
    } catch (error) {
      toast.error("Error obteniendo las encuestas")
      console.log(error)
    } finally {
      setLoadingStatus(false)
    }
  }

  const getCreatedSurveys = async () => { // Obtener las plantillas ya creadas
    try {
      const response = await axios.get(`${BACKEND}/api/encuestaSatisfaccion?limit=0`)
      setSurveysCreated(response.data.docs)
    } catch (error) {
      toast.error("Error cargando las encuestas creadas")
    }
  }

  const assignNewSurvey = async () => { // Asignar nuevo formulario al servicio

    if (surveyType === "Sin plantilla") {
      try {
        const responseSurvey = await axios.post(`${BACKEND}/api/encuestaSatisfaccion`, {
          title: titleNewSurvey,
          description: descriptionNewSurvey
        })

        const response = await axios.post(`${BACKEND}/api/encuestaSatisfaccionRespuesta`, {
          survey: responseSurvey.data.doc.id,
          serviceCot: serviceId
        })

        setServiceSurveys((prev) => [
          ...prev, response.data.doc
        ])

      } catch (error) {
        console.log(error)
        toast.error("Error al asignar la encuesta: " + error)
      }
    } else {
      try {
        const response = await axios.post(`${BACKEND}/api/encuestaSatisfaccionRespuesta`, {
          survey: surveyType,
          serviceCot: serviceId
        })

        setServiceSurveys((prev) => [
          ...prev, response.data.doc
        ])

      } catch (error) {
        toast.error("Error al asignar la encuesta: " + error)
        console.log(error)
      }
    }
  }

  const getSelectedSurvey = async () => { // Cuando se selecciona una encuesta traer las respuestas de la misma
    try {
      setLoadingSurvey(true)
      const response = await axios.get(`${BACKEND}/api/encuestaSatisfaccionPregunta?where[survey][equals]=${selectedSurveyId}`)
      setSelectedSurveyQuestions(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error obteniendo la encuesta: " + error)
    } finally {
      setLoadingSurvey(false)
    }
  }

  useEffect(() => { // Cada que cambia el servicio seleccioando cambiamos la pantalla
    getSelectedSurvey()
  }, [selectedSurveyId])

  useEffect(() => { // Arranque de componente
    getSurvey()
    getCreatedSurveys()
  }, [])

  //////////// Entrego de encuesta ///////////////////////

  const [answerFormValues, setAnswerFormValues] = useState({
    worker: user.id,
    answered: true,
    surveyed: "",
    answers:[],
    evidence:[],
    deliverDate: new Date().toISOString(),
    surveyed: ""
  })

  ////////////// Subir evidencias de la encuesta ///////////////////////

  const [filesToUpload, setFilesToUpload] = useState([])


  const uploadFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
  
      const response = await axios.post(
        `${BACKEND}/api/encuestaSatisfaccionEvidencia`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data && response.data.doc && response.data.doc.id) {
        return response.data.doc.id;
      } else {
        throw new Error("El ID del archivo no se encontró en la respuesta.");
      }
    } catch (error) {
      toast.error("Error al subir el archivo")
      return null;
    }
  };

  const handleDeliverSurvey = async () => {
    if (answerFormValues.answers.length !== selectedSurveyQuestions.length) {
      toast.warning("Faltan preguntas por responder")
      return
    } 

    if (answerFormValues.surveyed === "") {
      toast.warning("Se debe introducir el nombre de la persona encuestada")
      return
    }

    if (filesToUpload.length === 0) {
      toast.warning("Debes subir al menos una imagen de evidencia")
    }

    try {

      let mediaIds = [];

      if (filesToUpload.length > 0) {
        for (const file of filesToUpload) {
          const id = await uploadFile(file);
          if (id) {
            mediaIds.push(id);
          }
        }
      }

      const updatedFormValues = {
        ...answerFormValues,
        evidence: mediaIds, // Asigna las IDs de los archivos subidos
      };
  

      await axios.put(
        `${BACKEND}/api/encuestaSatisfaccionRespuesta/${selectedSurvey.id}`,
        updatedFormValues // Envía directamente el objeto estructurado correctamente
      );

      setAnswerFormValues({
        worker: user.id,
        answered: true,
        surveyed: "",
        answers:[],
        evidence:[],
        deliverDate: new Date().toISOString(),
        surveyed:""
      })
      setFilesToUpload([])
      getSurvey()
      setSelectedSurveyId("")
      setSelectedSurveyQuestions([])
      setSurveyViewActive(false)
      setSelectedSurvey({})
      toast.success("Encuesta guradada con éxito");
    } catch (error) {
      console.error(error);
      toast.error("Error al guardar la encuesta");
    }
  };

  const handleSurveyLocal = (value, answerId, typeAnswer, score = null) => {
    const fieldToUpdate = typeAnswer === "Respuesta cerrada" ? "closeAnswer" : "openAnswer";
  
    setAnswerFormValues((prev) => {
      const existingAnswerIndex = prev.answers.findIndex((answer) => answer.question === answerId);
  
      if (existingAnswerIndex !== -1) {
        // Actualizar respuesta existente
        return {
          ...prev,
          answers: prev.answers.map((answer, index) =>
            index === existingAnswerIndex
              ? {
                  ...answer,
                  ...(value !== null ? { [fieldToUpdate]: value } : {}), // Actualiza texto o respuesta cerrada
                  ...(score !== null ? { score } : {}), // Actualiza puntaje si existe
                }
              : answer
          ),
        };
      }
  
      // Agregar una nueva respuesta
      return {
        ...prev,
        answers: [
          ...prev.answers,
          {
            question: answerId,
            ...(value !== null ? { [fieldToUpdate]: value } : {}),
            score: score || 0,
          },
        ],
      };
    });
  };

  /////////////////////// Eliminación de encuesta //////////////////////////////

  const deleteSurvey = async (id) => {
    try {
      await axios.delete(`${BACKEND}/api/encuestaSatisfaccionRespuesta/${id}`)
      toast.success("Encuesta eliminada exitosamente")
      getSurvey()
    } catch (e) {
      console.log(e)
      toast.error("Error al eliminar la encuesta")
    }
  }

  /// Crear nuevas preguntas y asignarlas a la encuesta modificando la plantilla

  // const [newQuestionModal, setNewQuestionModal] = useState(false)

  // const [newQuestionForm, setNewQuestionForm] = useState({
  //   survey: "",
  //   type: "Respuesta abierta",
  //   description: "",
  //   maxScore: 5
  // })

  // useEffect(() => {
  //   setNewQuestionForm((prev) => ({
  //     ...prev,
  //     survey: selectedSurveyId,
  //   }));
  // }, [selectedSurveyId]);
  

  // const createNewQuestion = async () => {
  //   try {
  //     console.log(newQuestionForm)
  //     const responseQuestion = await axios.post(`${BACKEND}/api/encuestaSatisfaccionPregunta`, newQuestionForm)
  //     setSelectedSurveyQuestions((prev) => [...prev, responseQuestion.data.doc])
  //   } catch (error) {
  //     console.log(error)
  //     toast.error("Error al postear la pregunta")
  //   }
  // }


  return (
    <div className="flex flex-grow rounded-md">

      <Modal
        title="Asignar encuesta" 
        activeModal={newSurveyModal} 
        onClose={() => setNewSurveyModal(false)}
        centered
      >
        <div className="flex flex-col items-center gap-4">
          <span className="text-xs font-bold">¿Qué encuesta deseas asignar a este servicio?</span>
          <select 
            name="surveyType" 
            id="surveyType"
            value={surveyType}
            onChange={(e) => setSurveyType(e.target.value)}
            className="bg-gray-50 hover:cursor-pointer text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"

          >
            <option value="Seleccionar">Seleccionar</option>
            {surveysCreated.map((survey) => (
              <option value={survey.id}>{survey.title}</option>
            ))}
          </select>
          {/* {surveyType === "Sin plantilla" && (
            <div className="flex flex-col items center gap-4 w-full">

              <div className="flex flex-col gap-1">
                <span className="font-semibold text-xs">Título de la encuesta</span>
                <input 
                  type="text"
                  value={titleNewSurvey}
                  onChange={(e) => setTitleNewSurvey(e.target.value)}
                  className="text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
                />
              </div>

              <div className="flex flex-col gap-1">
                <span className="font-semibold text-xs">Descripción de la encuesta</span>
                <input 
                  type="text"
                  value={descriptionNewSurvey}
                  onChange={(e) => setDescriptionNewSurvey(e.target.value)} 
                  className="text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"  
                />
              </div>
            </div>
          )} */}
          
          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              fontSize: "small",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => {
              assignNewSurvey()
              setNewSurveyModal(false)
              setTitleNewSurvey("")
              setDescriptionNewSurvey("")
            }}
            
          >
            Asignar encuesta
          </Button>
        </div>
      </Modal>

      <Modal
        title="Evidencia "
        activeModal={evidenceModal}
        onClose={() => {
          setEvidenceModal(false)
          setEvidenceToView([])
        }}
        centered
      >
        <div className="max-h-[80%] flex flex-col overflow-y-auto gap-4">
          {evidenceToView.map((evidence, index) => (
            <div key={index} className="flex justify-center">
              <img
                src={evidence.url} // Usa la propiedad URL para mostrar la imagen
                alt={`Evidencia ${index + 1}`} // Texto alternativo único por imagen
                className="max-w-full max-h-64 object-contain" // Asegura que la imagen se ajuste bien al contenedor
              />
            </div>
          ))}
        </div>
      </Modal>

      {/* <Modal
        title="Agregar pregunta"
        activeModal={newQuestionModal}
        onClose={() => setNewQuestionModal(false)}
        centered
      >
        <div className="flex flex-col gap-8">
          <span className="text-xs font-bold text-center">Ingresa la información para generar una nueva pregunta y asignarla a esta encuesta</span>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Tipo de respuesta</span>
            <select
              onChange={(e) => setNewQuestionForm((prev) => ({...prev, type: e.target.value}))}
              className="hover:cursor-pointer w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            >
              <option value="Respuesta abierta">Respuesta abierta</option>
              <option value="Respuesta cerrada">Respuesta cerrada</option>
            </select>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Pregunta</span>
            <input
              type="text"
              placeholder="Descripción de la pregunta"
              onChange={(e) => setNewQuestionForm((prev) => ({...prev, description: e.target.value}))}
              className="w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            />
          </div>

          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              fontSize: "small",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => createNewQuestion()}
          >
            Crear pregunta
          </Button>
          
        </div>
      </Modal> */}

        {loadingStatus ? (

          <div className="flex-grow flex items-center justify-center gap-4 border m-4 rounded shadow">
            <FaSpinner className="animate-spin text-gray-500 h-4 w-4" />
            <span className="text-xs text-gray-500">Cargando...</span>
          </div>

        ) : surveyViewActive ? (
          loadingSurvey ? (

            <div className="flex-grow flex items-center justify-center gap-4 border m-4 rounded shadow">
              <FaSpinner className="animate-spin text-gray-500 h-4 w-4" />
              <span className="text-xs text-gray-500">Cargando encuesta... </span>
            </div>

          ) : (
            // Encuesta seleccionada
            <div className="flex flex-col w-full gap-4 m-4">

              {/* Header */}
              <div className="flex flex-row w-full justify-between items-center bg-gray-50 p-4 rounded-md shadow-md border border-gray-200">
                {/* Título y descripción */}
                <div className="flex flex-col gap-2">
                  <h1 className="text-sm font-extrabold text-gray-700">{selectedSurvey?.survey?.title}</h1>
                  <p className="text-xs text-gray-600">{selectedSurvey?.survey?.description}</p>
                  <div className="flex items-center gap-2">
                    <span
                      className={`text-xs font-bold px-2 py-0.5 rounded-lg ${
                        selectedSurvey.answered ? "bg-green-200 text-green-700" : "bg-red-200 text-red-700"
                      }`}
                    >
                      {selectedSurvey.answered ? "Respondido" : "No respondido"}
                    </span>
                    {selectedSurvey.answered && (
                      <span className="text-xs font-semibold text-gray-700">
                        Puntaje Total:{" "}
                        {selectedSurvey.answers.reduce((total, answer) => total + (answer.score || 0), 0)}
                      </span>
                    )}
                    
                  </div>
                  <div className="flex flex-row gap-2 items-center justify-between">
                    <span className="text-xs font-bold rounded-lg w-24">Encuestado:</span>
                    {selectedSurvey.answered ? (
                      <span className="text-xs rounded-lg flex-1 border border-gray-300 p-1">
                        {selectedSurvey.surveyed}
                      </span>
                    ) : (
                      <input
                        type="text"
                        placeholder="Persona que fue encuestada"
                        onChange={(e) =>
                          setAnswerFormValues((prev) => ({ ...prev, surveyed: e.target.value }))
                        }
                        className="text-xs border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 py-1 px-2 flex-1"
                      />
                    )}
                  </div>

                  <div className="flex flex-row gap-2 items-center justify-between">
                    <span className="text-xs font-bold rounded-lg w-24">Evidencia:</span>
                    {selectedSurvey.answered ? (
                      <span 
                        className="text-xs rounded-lg flex-1 hover:underline hover:cursor-pointer p-1 flex items-center"
                        onClick={() => {
                          setEvidenceToView(selectedSurvey.evidence)
                          setEvidenceModal(true)
                        }}
                      >
                        Ver <FaImage className="ml-2" />
                      </span>
                    ) : (
                      <input
                        type="file"
                        multiple
                        className="text-xs border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 flex-1"
                        accept="image/*"
                        onChange={(e) => {
                          const maxFileSize = 5 * 1024 * 1024; // 5 MB en bytes
                          const files = Array.from(e.target.files).filter((file) => {
                            if (!file.type.startsWith("image/")) {
                              toast.warning(
                                `El archivo "${file.name}" no es una imagen válida y no será agregado.`
                              );
                              return false;
                            }
                            if (file.size > maxFileSize) {
                              toast.warning(
                                `El archivo "${file.name}" excede el límite de 5 MB y no será agregado.`
                              );
                              return false;
                            }
                            return true;
                          });
                          setFilesToUpload((prevFiles) => [...prevFiles, ...files]); // Agrega archivos válidos al estado
                        }}
                      />
                    )}
                  </div>
                </div>

                {/* Botón de atrás */}
                <button
                  className="bg-red-500 hover:bg-red-600 text-white flex flex-row items-center justify-center gap-2 font-semibold text-xs py-1 px-4 rounded-md shadow-md transition-all duration-100"
                  onClick={() => {
                    setSelectedSurveyId("");
                    setSelectedSurveyQuestions([]);
                    setSurveyViewActive(false);
                    setSelectedSurvey({});
                  }}
                >
                  Atrás
                  <FaArrowLeft />
                </button>
              </div>

              {/* Body */}
              <div className="grid grid-cols-4 gap-4 w-full items-start">

                {selectedSurvey.answered ? (
                  selectedSurveyQuestions.map((answer, index) => (
                    <div
                      key={index}
                      className="p-2 h-full bg-white rounded-lg shadow-md border border-gray-200"
                    >
                      <div className="flex h-full flex-col bg-gray-100 justify-between p-2 rounded-md gap-4"> 
                        <div className="flex flex-col justify-center gap-2">
                          <h2 className="text-xs font-semibold text-gray-700">
                            Pregunta {index + 1}: {answer?.description}
                          </h2>
                          <span className="text-xs">{answer?.type}</span>
                          {/* <span className="text-xs">{answer?.worker?.name}</span> */}
                        </div>
                        {answer?.type === "Respuesta abierta" ? (
                          <div className="flex flex-col gap-2">
                            <span className="text-xs text-gray-900 py-1 px-2 w-full">
                              <span className="font-bold">Respuesta:{" "}</span>
                              {selectedSurvey.answers.find((question) => question.question.id === answer.id)?.openAnswer}
                            </span>
                            <span className="text-xs text-gray-900 py-1 px-2 w-full">
                              <span className="font-bold">Puntaje:{" "}</span>
                              {selectedSurvey.answers.find((question) => question.question.id === answer.id)?.score}
                            </span>
                          </div>
                        ) : (
                          <div className="flex flex-col gap-2">
                            <span className="text-xs text-gray-900 py-1 px-2 w-full">
                              <span className="font-bold">Respuesta:{" "}</span>
                              {selectedSurvey.answers.find((question) => question.question.id === answer.id)?.closeAnswer}
                            </span>
                            <span className="text-xs text-gray-900 py-1 px-2 w-full">
                              <span className="font-bold">Puntaje:{" "}</span>
                              {selectedSurvey.answers.find((question) => question.question.id === answer.id)?.score}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    {selectedSurveyQuestions?.map((item, index) => (
                      <div
                        key={index}
                        className="p-2 h-full bg-white rounded-lg shadow-md border border-gray-200"
                      >
                        <div className="flex h-full flex-col bg-gray-100 justify-between p-2 rounded-md gap-4">
                          <div className="flex flex-col justify-center gap-2">
                            <h2 className="text-xs font-semibold text-gray-700">
                              Pregunta {index + 1}: {item?.description}
                            </h2>
                            <span className="text-xs">{item?.type}</span>
                            {/* <span className="text-xs">Responsable: {item?.worker?.name}</span> */}
                          </div>
                          {item?.type === "Respuesta abierta" ? (
                            <div className="flex flex-col gap-2">
                              {/* Campo para capturar la respuesta abierta */}
                              <span className="text-xs font-semibold">Respuesta:{" "}</span>
                              <textarea
                                type="text"
                                onChange={(e) => handleSurveyLocal(e.target.value, item.id, item.type, null)} // Captura la respuesta abierta
                                placeholder="Respuesta"
                                className="text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 px-2 w-full"
                              />
                              {/* Campo adicional para capturar el puntaje */}
                              <div className="flex flex-row gap-2 items-center">
                                <label className="text-xs font-semibold text-gray-700">Puntaje:</label>
                                <input
                                  type="number"
                                  min={1}
                                  max={5}
                                  step={1}
                                  onChange={(e) => handleSurveyLocal(null, item.id, item.type, parseInt(e.target.value, 10))} // Captura el puntaje
                                  placeholder="1-5"
                                  className="text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 px-2 w-20"
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="flex flex-col gap-2">
                              <div className="flex flex-col gap-2">
                                <span className="text-xs font-semibold">Respuesta:{" "}</span>
                                <div className="flex flex-row justify-between px-4">
                                  {[1, 2, 3, 4, 5].map((value) => (
                                    <label key={value} className="flex flex-col gap-1 items-center">
                                      <input
                                        type="radio"
                                        name={`question-${item.id}`}
                                        value={value}
                                        checked={
                                          answerFormValues.answers.find((answer) => answer.question === item.id)?.closeAnswer === value.toString()
                                        }
                                        onChange={(e) => handleSurveyLocal(e.target.value, item.id, item.type, e.target.value)} // Captura la respuesta cerrada
                                        className="form-radio"
                                        disabled={item?.question?.survey?.answered} // Deshabilita si ya está entregada
                                      />
                                      <span className="text-xs font-bold">{value}</span>
                                    </label>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                    {/* <button
                      onClick={() => setNewQuestionModal(true)}
                      className="bg-blue-100 font-bold rounded-lg text-xs text-blue-500 h-full w-full shadow-md hover:bg-blue-200 hover:shadow-lg transition-all duration-200 flex-grow flex items-center justify-center gap-2"
                    >
                      <FaPlus /> Crear pregunta
                    </button> */}
                  </>
                )}
              </div>

              {!selectedSurvey.answered && (
                <div className="flex w-full items-center mt-4 justify-center">
                  <Button
                    variant="contained"
                    sx={{
                      fontWeight: "bold",
                      fontFamily: "poppins",
                      paddingBlock: "4px",
                      backgroundColor: "#ff6400",
                      transform: "all",
                      animationDuration: "1000",
                      textTransform: "none",
                      borderRadius: "8px",
                      width: "30%",
                      fontSize: "small",
                      '&:hover': {backgroundColor: "#bb4a03",}
                    }}
                    onClick={() => {
                      handleDeliverSurvey()
                    }}
                  >
                    Entregar encuesta
                  </Button>
                </div>
              )}
            </div>
          )
          ) : (

            // Encuestas del servicio
            <div className="flex-grow overflow-auto">
              <table className="w-full bg-gray-50">

                <thead>
                  <tr className="bg-gray-200 sticky top-0 z-10 text-xs">
                    <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">
                      <div className="flex items-center justify-center">
                        <FaTrash />
                      </div>
                    </th>
                    <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">Formulario</th>
                    <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">Fecha de entrega</th>
                    <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">Preguntas</th>
                    <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">Puntos</th>
                    <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">Encargado</th>
                    {/* <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">ID</th> */}
                    <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">Evidencia</th>
                    <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">Encuestado</th>
                    <th className="p-2 border-none text-xs font-bold text-zinc-700 whitespace-pre-line">Estado</th>
                  </tr>
                </thead>

                <tbody>
                  {serviceSurveys.map((survey, index) => (
                    <tr 
                      key={index} 
                      className="bg-white text-xs text-zinc-700 whitespace-pre-line hover:bg-gray-100 transition-all duration-100"
                    >
                      <td scope="row" className="py-2 border px-4 text-center">
                        <div
                          className="flex items-center justify-center hover:cursor-pointer transition-all duration-100" 
                          onClick={() => deleteSurvey(survey.id)}
                        >
                          <FaTrash className="text-red-500"/>
                        </div>
                      </td>
                      <td 
                        className="py-2 border px-4 hover:underline font-bold text-center hover:cursor-pointer "
                        onClick={() => {
                          setSelectedSurveyId(survey.survey.id)
                          setSurveyViewActive(true)
                          setSelectedSurvey(survey)
                        }}  
                      >
                        {survey.survey?.title}
                      </td>
                      <td className="py-2 border px-4 text-center">
                        {survey.answered ? (new Date(survey.deliverDate).toLocaleDateString("es-ES", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })) : (
                            <span>-</span>
                          )
                        }
                      </td>
                      <td className="py-2 border px-4 text-center">
                        {survey.answers?.length ? survey.answers?.length : "0"}
                      </td>
                      <td className="py-2 border px-4 text-center">
                        {survey.answers ? (
                          (() => {
                            const result = survey.answers.reduce(
                              (acc, answer) => {
                                acc.totalScore += answer.score;
                                acc.maxScore += answer.question.maxScore;
                                return acc;
                              },
                              { totalScore: 0, maxScore: 0 }
                            );
                            return `${result.totalScore} / ${result.maxScore}`;
                          })()
                        ) : (
                          <span className="text-xs text-gray-700">-</span>
                        )}
                      </td>
                      <td className="py-2 border px-4 text-center">
                        {survey.worker?.name ? survey.worker.name : "-"}
                      </td>
                      {/* <td className="py-2 border px-4 text-center">
                        {survey.id}
                      </td> */}
                      <td className="py-2 border px-4 text-center items-center">
                        <div className="flex items-center justify-center">
                          {survey.evidence && survey.evidence.length ? (
                            <button 
                              onClick={() => {
                                setEvidenceToView(survey.evidence)
                                setEvidenceModal(true)
                              }}
                              className="flex justify-start gap-2 items-center p-2 rounded-md cursor-pointer  bg-blue-600 text-blue-700 bg-opacity-10 hover:bg-opacity-20 hover:text-blue-700 hover:border-blue-400 transition duration-100"
                            >
                              <FaEye />
                            </button>
                          ) : (
                            <div
                              className="flex justify-start gap-2 items-center p-2 rounded-md cursor-pointer bg-gray-600 text-gray-700 bg-opacity-10"
                            >
                              <FaEyeSlash />
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="py-2 border px-4 text-center">
                        {survey.surveyed ? survey.surveyed : "-"}
                      </td>
                      <td className="py-2 border px-4 text-center">
                        <span className={`text-xs font-bold ${survey.answered ? "text-green-500" : "text-red-500"}`}>{survey.answered ? "Respondido" : "No respondido"}</span>
                      </td>
                    </tr>
                  ))}
                  <td className="py-2 text-center items-center" colSpan={9}>
                    <button 
                      className="p-2 bg-blue-100 h-full w-full shadow-md border border-gray-200 hover:bg-blue-200 hover:shadow-lg transition-all duration-200 flex-grow flex items-center justify-center gap-2"
                      onClick={() => setNewSurveyModal(true)}  
                    >
                      <FaPlus className="text-blue-600 h-4 w-4" />
                      <span className="text-xs font-bold text-blue-700">Crear encuesta</span>
                    </button>
                  </td>
                </tbody>

              </table>

            </div>
        )}


    </div>
  )
}

export default SeguimientoFormularioScreen



      // <div className="w-full">
      //   <div className="grid grid-cols-4 gap-4 w-full items-start">
      //     {serviceSurveys.map((survey) => (

      //       <div 
      //         key={survey.survey.id} 
      //         className="p-2 h-full bg-white rounded-lg shadow-md border border-gray-200 hover:cursor-pointer hover:shadow-lg transition-all duration-100" 
      //         onClick={() => {
      //           setSelectedSurveyId(survey.survey.id)
      //           setSurveyViewActive(true)
      //           setSelectedSurvey(survey)
      //         }}
      //       >
      //         <div className="flex h-full flex-col gap-2">
      //           {/* Información de la encuesta */}
      //           <div className="flex h-full flex-col bg-orange-100 p-2 rounded-md">
      //             <h2 className="text-sm font-bold text-gray-700">{survey.survey?.title}</h2>
      //             <p className="text-xs font-semibold text-gray-600">{survey.survey?.description}</p>
      //           </div>
      //         </div>
      //       </div>

      //     ))}

      //     <button 
      //       className="p-3 bg-blue-100  rounded-lg h-full shadow-md border border-gray-200 hover:bg-blue-200 hover:shadow-lg transition-all duration-200 flex-grow flex items-center justify-center gap-2"
      //       onClick={() => setNewSurveyModal(true)}  
      //     >
      //       <FaPlus className="text-blue-600 h-4 w-4" />
      //       <span className="text-sm font-bold text-blue-700">Crear encuesta</span>
      //     </button>

      //   </div>
      // </div>

      